import React, { Component } from 'react';

import { connect } from 'react-redux';


class TextOnlyLayout extends Component {
    setNextScene = () => {
        this.props.dispatch({ type: 'ADD_TO_HISTORY', payload: { current_scene: 2, previous_scene: 1 } });
        this.props.dispatch({ type: 'SET_ACTIVE_SCENE', payload: this.props.lessonData[2] })
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <div className="layout-page flex-box flex-center">
                {/* this scene has a title, some action buttons, stored in an array, with type data, visual elements (how many? what type?) stored in an array, with type data, and data about next available scenes, stored in an array */}
                <div className="column-lg-10 column-md-12 column-sm-12">

                    <div className="flex-box flex-evenly">
                        <img src={this.props.activeScene.images[0].image} alt={this.props.activeScene.images[0].alt} className="column-lg-6 column-md-12 column-sm-12 text-shadow title-image" />
                        <div className="column-lg-5 column-md-12 column-sm-12">
                            <h2 className="lesson-title">{this.props.activeScene.title}</h2>
                            <div className="flex-box flex-center">
                                <button className="button" onClick={(event) => this.setNextScene()}>Start lesson</button>
                            </div>
                        </div>
                    </div>
                </div>



            </div>

        );
    }
}
const mapStateToProps = state => ({
    activeScene: state.activeScene,
    lessonData: state.lessonData
})
export default connect(mapStateToProps)(TextOnlyLayout);